import { Dashboard } from "../../../../dashboards/components/Dashboard"
import { PurchaseSection } from "../statistics/PurchaseSection"
import { MatchEnvironment } from "../../../../environment/components/MatchEnvironment"
import { EnvironmentType } from "../../../../environment/envTypes"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { ComingSoonPlaceholder } from "../../../../../shared/components/placeholders/ComingSoonPlaceholder"

type Props = Readonly<{}>

export function CompanyReportsHome({}: Props) {
    return (
        <>
            <MatchEnvironment environments={[EnvironmentType.Prod]}>
                <LocalizedStrict id="planning-tabs-placeholder" attrs={{ title: true, body: true }}>
                    <ComingSoonPlaceholder title="Coming soon" body="We are working to bring you this feature." />
                </LocalizedStrict>
            </MatchEnvironment>
            <MatchEnvironment
                environments={[EnvironmentType.Local, EnvironmentType.Test, EnvironmentType.Demo, EnvironmentType.QA]}
            >
                <Dashboard>
                    <PurchaseSection />
                </Dashboard>
            </MatchEnvironment>
        </>
    )
}
